import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../context/Authcontext";

import star from "../assets/star.svg";

const Listformation = () => {
  const navigate = useNavigate();
  const { contextData } = useContext(AuthContext);
  const [formations, setformations] = useState([]);
  let [imageUrl, setImageUrl] = useState([]);
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message

  useEffect(() => {
    getformations();
  }, []);

  //this gets the images for the formations
  const getFiles = async (ids) => {
    const responses = await Promise.all(
      ids.map(async (id) => {
        const response = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/formations/image/${id}/`,
          {
            responseType: "blob",
          }
        );
        return response.data;
      })
    );

    const blobs = responses.map((response) => new Blob([response]));

    let urls = blobs.map((blob) => window.URL.createObjectURL(blob));

    for (let i = 0; i < urls.length; i++) {
      const image = document.getElementById(`image-${i}`);
      image.src = urls[i];
    }
  };

  const getformations = async () => {
    let list = [];

    let responce;
    try {
      responce = await axios.get(
        "https://pfebackend-zbz0.onrender.com/api/formations/user/",
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    setformations(responce.data);
    responce.data.map((e) => list.push(e.id));
    getFiles(list);
  };

  const handelshoseformation = async (e) => {
    navigate(`/formation/${e.id}/`);
  };

  return (
    <div>
      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      <div className="courses-container-all">
        {formations.map((e, i) => {
          return (
            <article
              onClick={() => handelshoseformation(e)}
              key={i}
              className="card"
            >
              {imageUrl ? (
                <img
                  className={`card-image  ${e.id}`}
                  src={imageUrl}
                  id={`image-${i}`}
                  alt=""
                />
              ) : (
                <p>Loading image...</p>
              )}
              <div className="card-text-container">
                <h5 className="card-title">{e.name}</h5>
                <p className="card-discrition">
                  {e.description.substring(0, 70) + "..."}
                </p>
                <div className="rating-container">
                  <img className="star" src={star} alt="" />
                  <p className="rating">{e.rating}</p>
                </div>
                <p className="price">{e.price} Da</p>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default Listformation;
